<template name="u-time">
  <div>
    <van-field
      v-bind="$attrs"
      @click="clickTime"
      :value="name"
      :placeholder="placeholder"
      readonly
      clickable
      :input-align="inputAlign"
      :right-icon="rightIcon"
    />

    <van-popup v-model="show" position="bottom">
      <van-datetime-picker
        v-model="choiceTime"
        show-toolbar
        @confirm="onConfirm"
        @cancel="show = false"
        :type="type"
        :title="title"
        :formatter="formatter"
        :min-date="minMaxDate[0]"
        :max-date="minMaxDate[1]"
      />
    </van-popup>
  </div>
</template>

<script>
/**
 *
 * @description
 */
import { formatDate } from '@/utils/util.js'
export default {
  name: 'u-time',
  props: {
    placeholder: {
      type: String,
      default: '请选择',
    },
    value: {
      type: String,
      default: '',
    },
    inputAlign: {
      type: String,
      default: 'right',
    },
    rightIcon: {
      type: String,
      default: 'arrow-down',
    },
    type: {
      type: String,
      default: 'date',
    },
    title: {
      type: String,
      default: '请选择年月日',
    },
    timeRange: {
      type: Array,
      default: () => [],
    },
    fmt: {
      type: String,
      default: 'yyyy-MM-dd',
    },
     isClick: {
      type: Boolean,
      default: true,
    },
  },
  created() {
    this.choiceTime = this.$attrs.currentDate || new Date()
  },
  data() {
    return {
      show: false,
      name: '',
      choiceTime: '',
    }
  },
  watch: {
    value: {
      immediate: true,
      handler() {
        console.log(this.value)
        this.name = this.value
      },
    },
    isClick: {
      immediate: true,
      handler() {
        this
      },
    },
  },
  computed: {
    minMaxDate: function () {
      // Vant with minDate and maxDate must date type
      let { timeRange } = this

      if (timeRange.length) {
        if (!timeRange[1]) timeRange[1] = new Date()

        timeRange[0] = timeRange[0] instanceof Date ? timeRange[0] : new Date(timeRange[0].replace(/-/g, '/'))
        timeRange[1] = timeRange[1] instanceof Date ? timeRange[1] : new Date(timeRange[1].replace(/-/g, '/'))

        if (isNaN(timeRange[0].getTime()) || isNaN(timeRange[1].getTime())) throw new Error('timeRange时间格式错误！')
      } else {
        timeRange = [new Date('1900-05'), new Date()]
      }

      return timeRange
    },
  },
  methods: {
    onConfirm(e) {
      let time = formatDate(e.getTime(), this.fmt)
      this.$emit('input', time)
      this.$emit('change', e)
      this.show = false
    },
    formatter(type, val) {
      if (type === 'year') {
        return `${val}年`
      } else if (type === 'month') {
        return `${val}月`
      } else if (type === 'day') {
        return `${val}日`
      } else if (type === 'hour') {
        return `${val}时`
      } else if (type === 'minute') {
        return `${val}分`
      }
      return val
    },
    clickTime(){
      if(!this.isClick)return;
      this.show = true;
    }
  },
}
</script>

<style lang="less" scoped>
</style>
